import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomValidator } from '@helpers/custom-validator';
import { FormControl, UntypedFormControl } from '@angular/forms';
import { environment } from '@env/environment';
import { enumFileExtension } from '@enum/enumFileExtension';
import { enumMimeType } from '@enum/enumMimeType';
import { ALLOWED_FILE_MIMES } from '@constants/constants';

@Component({
  selector: 'document-upload-multiple-placeholder',
  templateUrl: './document-upload-multiple-placeholder.component.html',
  styleUrls: ['./document-upload-multiple-placeholder.component.scss'],
})
export class DocumentUploadMultiplePlaceholderComponent implements OnInit {
  @Input() public id: string = 'file-input-multiple';
  @Input() public fileName: string;
  @Input() public validators: any[] = [
    CustomValidator.fileExtensions([enumFileExtension.XLS, enumFileExtension.XLSX]),
    CustomValidator.maxFileSize(environment.files.import_file_size_limit),
  ];
  @Input() public allowedFileMimes: typeof ALLOWED_FILE_MIMES = [enumMimeType.XLS, enumMimeType.XLSX];
  @Input() public isSmallIcon: boolean;
  @Input() public header: string;
  @Input() public headerHint: string;
  @Input() public headerUploaded: string;
  @Input() public footerHint: string = 'LABELS.DRAG_N_DROP_FOR_UPLOAD';
  @Output() public upload: EventEmitter<File[]> = new EventEmitter<File[]>();

  public fileControl: UntypedFormControl;
  public errors: { [name: string]: string } = {
    maxFileSize: 'FORM_ERROR.MAX_FILE_SIZE',
    onlyImage: 'FORM_ERROR.FILE_EXTENSION_NOT_ALLOWED',
  };

  public uploadedAdditionalFiles: File[] = [];

  public isUploadingDoc: boolean;

  constructor(private cdr: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.fileControl = new FormControl(null, this.validators);
  }

  public uploadFile(files: FileList): void {
    if (files) {
      for (let i: number = 0; i < files.length; i++) {
        this.isUploadingDoc = true;
        const reader: FileReader = new FileReader();
        reader.readAsDataURL(files.item(i));

        reader.onload = () => {
          this.clearFile();
          this.fileControl.patchValue(files.item(i));
          this.fileControl.markAsTouched();

          if (this.fileControl.valid) {
            this.uploadedAdditionalFiles.push(files.item(i));
            this.upload.emit(this.uploadedAdditionalFiles);
          }
          this.isUploadingDoc = false;

          this.cdr.markForCheck();
        };
      }
    }
  }

  public onRemoveAdditionalFile(index: number): void {
    this.uploadedAdditionalFiles.splice(index, 1);
    this.upload.emit(this.uploadedAdditionalFiles);
  }

  private clearFile(): void {
    this.fileControl.patchValue(null);
    this.fileControl.markAsUntouched();
  }
}
